import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/bo/users/$userId_/unpaid-invoices')({
  component: Outlet,
})
